import {Component, EventEmitter, HostListener, OnInit, Output} from '@angular/core';
import {CardsHistoryService} from "../service/cards-history.service";
import {CardsHistoryResponse} from "../interface/cardsHistoryResponse";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {DeleteProfileCardComponent} from "../profile-card/delete-profile-card/delete-profile-card.component";
import {ImageType} from "../enums/image-type-enum";
import {FavoriteCardsService} from "../service/favorite-cards.service";
import {FavoriteCardsResponse} from "../interface/favoriteCardsResponse";
import {event} from "jquery";
import {ViewStateService} from "../service/view-state.service";
import {
  DELETE_ALL_FAVORITES_CARD_TITLE,
  DELETE_ALL_VIEWED_CARD_TITLE,
  DELETE_DESCRIPTION,
  DELETE_FAVORITE_CARD_TITLE,
} from "../constants/deleteProfileCards.constant";
import {HeaderFactoryService} from "../header/header-factory.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-cards-history',
  templateUrl: './cards-history.component.html',
  styleUrls: ['./cards-history.component.scss', 'cards-history-media.component.scss']
})
export class CardsHistoryComponent implements OnInit {

  cardsHistory: CardsHistoryResponse[] = [];
  favoriteCards: FavoriteCardsResponse[] = [];

  viewedCardsPage: number = 0;
  viewedCardsSize: number = 9;
  viewedCardsTotalPages: number = 0;

  favoriteCardsPage: number = 0;
  favoriteCardsSize: number = 9;
  favoriteCardsTotalPages: number = 0;

  isViewedCards: boolean = true;
  isLoading: boolean = false;
  isListView: boolean = false;
  isFavoriteMap: { [key: string]: boolean } = {};

  dialogRef: MatDialogRef<DeleteProfileCardComponent> | undefined;

  protected readonly ImageType = ImageType;
  protected readonly event = event;

  @Output() deleteCard = new EventEmitter<bigint>();

  constructor(
    private dialog: MatDialog,
    private scannedHistoryService: CardsHistoryService,
    private favoriteCardsService: FavoriteCardsService,
    private viewStateService: ViewStateService,
    private translateService: TranslateService,
  ) {
    HeaderFactoryService.isViewedCards.next(true);
  }

  ngOnInit() {
    this.loadHistory();
    this.loadFavorites();
    this.getCardsViewFromHeader();
    this.getCardsStateFromHeader();
    this.subscribeToClearHistory();
    this.updateCardsViewHeader();
  }

  toggleViewedCard(isViewedCards: boolean): void {
    if (this.isViewedCards === isViewedCards) {
      return;
    }
    this.isViewedCards = isViewedCards;
    HeaderFactoryService.isViewedCards.next(isViewedCards);
    this.viewedCardsPage = 0;
    this.favoriteCardsPage = 0;
    this.isLoading = true;
    this.viewStateService.setIsViewedCards(isViewedCards);
    if (isViewedCards) {
      this.cardsHistory = [];
      this.loadHistory();
      this.updateCardsNameAndLength();
    } else {
      this.favoriteCards = [];
      this.loadFavorites();
      this.updateCardsNameAndLength();
    }
    this.initFavorites();
  }

  loadHistory() {
    this.scannedHistoryService.findAllByLoggedUser(this.viewedCardsPage, this.viewedCardsSize).subscribe({
      next: (response) => {
        this.cardsHistory = [...this.cardsHistory, ...response.content];
        this.viewedCardsTotalPages = response.totalPages;
        this.initFavorites();
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

  private initFavorites() {
    const ids = this.cardsHistory.map(card => card.userCardResponse.id);
    this.favoriteCardsService.getFavorites(ids).subscribe({
      next: (response) => {
        this.isFavoriteMap = response;
        this.updateCardsNameAndLength();
      }
    })
  }

  loadFavorites() {
    this.favoriteCardsService.findAllByUser(this.favoriteCardsPage, this.favoriteCardsSize).subscribe({
      next: (response) => {
        this.favoriteCards = [...this.favoriteCards, ...response.content];
        this.favoriteCardsTotalPages = response.totalPages;
        this.favoriteCards.forEach((favoriteCard: any) => {
          this.isFavoriteMap[favoriteCard.userCardResponse.id] = true;
          this.updateCardsNameAndLength();
        });
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

  onDelete(id: bigint, cardHistoryId: bigint, event: any) {
    event.stopPropagation();
          const deleteTitle = this.isViewedCards ? this.translateService.instant('cards_library.remove_viewed_card_modal_title') : DELETE_FAVORITE_CARD_TITLE;
    this.dialogRef = this.dialog.open(DeleteProfileCardComponent, {
      data: {
        deleteTitle: deleteTitle,
        deleteDescription: DELETE_DESCRIPTION,
      }
    });
    this.dialogRef.afterClosed().subscribe((result: MatDialogRef<DeleteProfileCardComponent>) => {
      if (result) {
        this.scannedHistoryService.deleteById(cardHistoryId).subscribe(() => {
          this.cardsHistory = this.cardsHistory.filter(card => card.userCardResponse.id !== id);
          this.deleteCard.emit(id);
          this.updateCardsNameAndLength()
        });
      }
    });
  }

  confirmClearHistory(event: any) {
    event.stopPropagation()
    const deleteTitle = this.isViewedCards ? DELETE_ALL_VIEWED_CARD_TITLE : DELETE_ALL_FAVORITES_CARD_TITLE;
    this.dialogRef = this.dialog.open(DeleteProfileCardComponent, {
      data: {
        deleteTitle: deleteTitle,
        deleteDescription: DELETE_DESCRIPTION,
      }
    });
    this.dialogRef.afterClosed().subscribe((result: MatDialogRef<DeleteProfileCardComponent>) => {
      if (result) {
        if (this.isViewedCards) {
          this.scannedHistoryService.deleteAllByLoggedUser().subscribe(() => {
            this.cardsHistory = [];
            this.updateCardsNameAndLength();
          });
        } else {
          this.favoriteCardsService.deleteAllFavoriteCardsByUser().subscribe(() => {
            this.favoriteCards = [];
            this.updateCardsNameAndLength();
          });
        }
      }
    });
  }

  getCardsViewFromHeader() {
    this.viewStateService.isListView$.subscribe(isListView => {
      this.isListView = isListView;
    });
  }

  @HostListener('window:scroll', ['$event'])
  private onScroll() {
    if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 100 && !this.isLoading) {
      this.loadMoreHistory();
      this.loadMoreFavorite();
    }
  }

  loadMoreHistory() {
    if (this.viewedCardsPage < this.viewedCardsTotalPages - 1) {
      this.isLoading = true;
      this.viewedCardsPage++;
      this.loadHistory();
    }
  }

  loadMoreFavorite() {
    if (this.favoriteCardsPage < this.favoriteCardsTotalPages - 1) {
      this.isLoading = true;
      this.favoriteCardsPage++;
      this.loadFavorites();
    }
  }

  getCardsStateFromHeader() {
    this.viewStateService.isViewedCards$.subscribe(isViewedCards => {
      this.isViewedCards = isViewedCards;
    });
  }

  subscribeToClearHistory(): void {
    this.viewStateService.isClearHistory$.subscribe(isViewedCards => {
      if (isViewedCards) {
        this.cardsHistory = [];
        this.updateCardsNameAndLength()
      } else if (!isViewedCards) {
        this.favoriteCards = [];
        this.updateCardsNameAndLength()
      }
    })
  }

  updateCardsNameAndLength() {
    if (this.isViewedCards) {
      const cardsHistoryLength = this.cardsHistory.length;
      HeaderFactoryService.cardsCount.next(cardsHistoryLength);
      this.viewStateService.setCardsNameAndLength('Viewed Cards ' + cardsHistoryLength);
    } else {
      const favoriteCardsLength = this.favoriteCards.length;
      HeaderFactoryService.cardsCount.next(favoriteCardsLength);
      this.viewStateService.setCardsNameAndLength('Favorites Cards ' + favoriteCardsLength);
    }
  }

  updateCardsViewHeader() {
    this.viewStateService.setListView(this.isListView);
  }

  isShowClearHistoryButton() {
    const isClearHistoryButtonActive = (this.isViewedCards && this.cardsHistory.length !== 0) || (!this.isViewedCards && this.favoriteCards.length !== 0);
    this.viewStateService.setIsClearHistoryActiveOnHeader(isClearHistoryButtonActive);
    return isClearHistoryButtonActive;
  }
}
